// payment
import ErrorPayment from "../../pages/charge/error/error";
import HomePayment from "../../pages/charge/home/home";
import SuccessPayment from "../../pages/charge/success/success";
// auth
import FirstStep from "../../pages/auth/firstStep/firstStep";
import SecondStep from "../../pages/auth/secondStep/secondStep";
import ThirdStep from "../../pages/auth/thirdStep/thirdStep";
import FoursStep from "../../pages/auth/fourseStep/fourthStep";
import FinalStep from "../../pages/auth/finalStep/finalStep";
// moghavemat
import Moghavemat from "../../pages/client/moghavemat/moghavemat";
import HelpSuccess from "../../pages/client/moghavemat/payment/success/success";
import HelpError from "../../pages/client/moghavemat/payment/error/error";
// hamiyan
import HamiyanSuccess from "../../pages/client/hamiyan/payment/success/success";
import HamiyanError from "../../pages/client/hamiyan/payment/error/error";
import Hamiyan from "../../pages/client/hamiyan/hamiyan";
// ezdevaj
import Ezdevaj from "../../pages/client/ezdevaj/ezdevaj";
import EzdevajSuccess from "../../pages/client/ezdevaj/payment/success/success";
import EzdevajError from "../../pages/client/ezdevaj/payment/error/error";
// update
import Home from "../../pages/client/home/home";
import NewSuccess from "../../pages/newPayment/success";
import NewError from "../../pages/newPayment/error";
import HomePaymentUser from "../../pages/auth/charge/home/home";
import ErrorPaymentUser from "../../pages/auth/charge/error/error";
import SuccessPaymentUser from "../../pages/auth/charge/success/success";
// import PaymentRedirect from "../../pages/client/redirect/paymentRedirect";
import HomePayment2 from "../../pages/charge/home/homePayment";
import HomePaymentGoya from "../../pages/charge/home/homeGoya";
import LogAdmin from "../../pages/client/logAdmin/logAdmin";
import Payment from "../../pages/client/home/payment";
import Make from "../../pages/newPayment/make";
import HomePaymentGoyaK from "../../pages/charge/home/homeGoyaK";
import MakeTwo from "../../pages/newPayment/make2";
import MakeThree from "../../pages/newPayment/make3";
import MakeCode from "../../pages/newPayment/makeCode";
import MakeMerchantRegister from "../../pages/newPayment/registerM";

// base routes
export const routes: any = {
    client: [
        // {
        //     label: 'پرداخت ها',
        //     address: '/:id',
        //     component: <PaymentRedirect />,
        // },
        {
            label: 'خانه',
            address: '/',
            component: <Home />,
            icon: '',
        },
        {
            label: 'خانه',
            address: '/register/:code',
            component: <Home />,
            icon: '',
        },
        {
            label: 'خانه',
            address: '/newSuccess',
            component: <NewSuccess />,
            icon: '',
        },
        {
            label: 'خانه',
            address: '/newError',
            component: <NewError />,
            icon: '',
        },
        {
            label: 'کمک به غزه',
            address: '/donate/moghavemat',
            component: <Moghavemat />,
            icon: '',
        },
        {
            label: 'پرداخت موفق کمک به غزه',
            address: '/transaction/moghavemat/success/:reference/:tracking/:amount',
            component: <HelpSuccess />,
            icon: '',
        },
        {
            label: 'پرداخت نا موفق کمک به غزه',
            address: '/transaction/moghavemat/errorText',
            component: <HelpError />,
            icon: '',
        },
        {
            label: 'کمک به نهضت',
            address: '/donate/hamiyan',
            component: <Hamiyan />,
            icon: '',
        },
        {
            label: 'پرداخت موفق کمک به نهضت',
            address: '/transaction/hamiyan/success/:reference/:tracking/:amount',
            component: <HamiyanSuccess />,
            icon: '',
        },
        {
            label: 'پرداخت نا موفق کمک به نهضت',
            address: '/transaction/hamiyan/errorText',
            component: <HamiyanError />,
            icon: '',
        },
        {
            label: 'کمک به زوجین',
            address: '/donate/ezdevaj',
            component: <Ezdevaj />,
            icon: '',
        },
        {
            label: 'پرداخت موفق کمک به زوجین',
            address: '/transaction/ezdevaj/success/:reference/:tracking/:amount',
            component: <EzdevajSuccess />,
            icon: '',
        },
        {
            label: 'پرداخت نا موفق کمک به زوجین',
            address: '/transaction/ezdevaj/errorText',
            component: <EzdevajError />,
            icon: '',
        },
        {
            label: 'پرداخت نا موفق کمک به زوجین',
            address: '/HDMerchants/partner-registration',
            component: <LogAdmin />,
            icon: '',
        },
        {
            label: 'پرداخت ها',
            address: '/:key/:id',
            component: <Payment />,
        },
        {
            label: 'پرداخت ها',
            address: '/hashin/:code',
            component: <Payment />,
        },
        {
            label: 'پرداخت ها',
            address: '/karma/:code',
            component: <Payment />,
        },
        {
            label: 'پرداخت ها',
            address: '/pollink/:code',
            component: <Payment />,
        },
        {
            label: 'پرداخت ها',
            address: '/:code',
            component: <Payment />,
        },
    ],
    // payment
    payment: [
        {
            label: 'شارژ حساب',
            address: '/payment/:key/transaction/:id',
            component: <HomePayment2 />,
        },
        {
            label: 'شارژ حساب',
            address: '/charge/:key/transaction/:id',
            component: <HomePayment />,
        },
        {
            label: 'شارژ حساب',
            address: '/payment/:key/:id',
            component: <HomePayment2 />,
        },
        {
            label: 'شارژ حساب',
            address: '/charge/:key/:id',
            component: <HomePayment />,
        },
        {
            label: 'شارژ حساب',
            address: '/HDMerchants/:id',
            component: <HomePaymentGoya />,
        },
        {
            label: 'شارژ حساب',
            address: '/HDMerchants/:name/:id',
            component: <HomePaymentGoyaK />,
        },
        {
            label: 'تراکنش موفق',
            address: '/transaction/success/:reference/:tracking',
            component: <SuccessPayment />,
        },
        {
            label: 'تراکنش نا موفق',
            address: '/transaction/errorText/:message',
            component: <ErrorPayment />,
        },
        {
            label: 'ایجاد تراکنش',
            address: '/InvoiceHDMerchants',
            component: <Make />,
        },
        {
            label: 'ایجاد تراکنش',
            address: '/Invoice',
            component: <MakeTwo />,
        },
        // {
        //     label: 'ایجاد تراکنش',
        //     address: '/settle',
        //     component: <MakeThree />,
        // },
        {
            label: 'ایجاد تراکنش',
            address: '/testLogin',
            component: <MakeCode />,
        },
        // {
        //     label: 'ایجاد تراکنش',
        //     address: '/page/register',
        //     component: <MakeMerchantRegister />,
        // },
    ],
    // auth
    auth: [
        {
            label: 'مرحله دوم',
            address: '/signUp/firstStep',
            component: <SecondStep />,
        },
        {
            label: 'مرحله اول',
            address: '/signUp/secondStep',
            component: <FirstStep />,
        },
        {
            label: 'مرحله سوم',
            address: '/signUp/thirdStep',
            component: <ThirdStep />,
        },
        {
            label: 'مرحله چهارم',
            address: '/signUp/foursStep',
            component: <FoursStep />,
        },
        {
            label: 'مرحله آخر',
            address: '/signUp/finalStep',
            component: <FinalStep />,
        },
        {
            label: 'مرحله آخر',
            address: '/signUp/payment',
            component: <HomePaymentUser />,
        },
    ],
    authPay: [
        {
            label: 'تراکنش نا موفق',
            address: '/signUp/errorText',
            component: <ErrorPaymentUser />,
        },
        {
            label: 'تراکنش موفق',
            address: '/signUp/success/:reference/:tracking/:code',
            component: <SuccessPaymentUser />,
        },
    ],
    api: [
        {
            name: 'api',
            address: 'https://apigateway.irantarakonesh.ir:443/api/',
            group: 'api'
        },
        //  payment
        {
            name: 'paymentApi',
            address: 'https://apigateway.irantarakonesh.ir:443/Landing/PaymentInfo',
            address_2: 'https://apigateway.irantarakonesh.ir:443/Landing/PaymentInfo',
            address_3: 'https://apigateway.irantarakonesh.ir:443/MerchantRegister/Referral',
            group: 'paymentApi'
        },
        // moghavemat
        {
            name: 'moghavemat',
            address: 'https://apigateway.irantarakonesh.ir:443/',
            group: 'moghavemat'
        }
    ]
}
